import { envVars } from '../envVars';

const redirect = (url: string): void => {
  window.location.assign(url);
};

const redirectToLogin = (): void => {
  redirect(envVars.URL_LOGIN);
};

const redirectToPayroll = (): void => {
  redirect(envVars.URL_PAYROLL);
};

export { redirect, redirectToLogin, redirectToPayroll };
